const bambooCartAttributesHelper = {
  async init() {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
  
 	
    const cookieArr = document.cookie.split('; ');
 
  	const cookiesToSave = ['_fbp', '_fbc', '_ga', '_ym_uid', 'jsFPID', 'yclid', 'gclid', 'gbraid', 'wbraid', 'admitad_uid'];
  
    const attributesToSave = {};
  

    cookiesToSave.forEach(oneCookieName => {
  	  const oneCookieRow = cookieArr.find(row => row.startsWith(`${oneCookieName}=`));

      
      const cookieValue =oneCookieRow ?  decodeURIComponent(decodeURIComponent(oneCookieRow.split('=')[1])) : null;
          
      
      if (oneCookieName === '_ga' && !cookieValue.includes('GA1.2.')) {
        return;
      }

      
	  const attributeName = `bamboo${oneCookieName}`;

      if (cookieValue !== cart.attributes[attributeName]) {
		attributesToSave[attributeName] = cookieValue;
      }
  	});



    if (Object.keys(attributesToSave).length === 0) {
      return;
    }

	
	fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes: attributesToSave })
    });
  }
};


bambooCartAttributesHelper.init();